import React, { useState } from 'react';
import ReorderOrderLineButton from '../Components/ReorderOrderLineButton';
import { useDispatch } from 'react-redux';
import { receive, loadError } from '../Actions/Cart.action';

export default function ReorderOrderLineButtonContainer({
  quantity,
  title,
  label,
  cssClass,
  articleNumber,
  cssButtonClass,
}) {
  const [parsedQuantity, setParsedQuantity] = useState(parseInt(quantity));
  const dispatch = useDispatch();

  async function onError(err) {
    dispatch(loadError(err));
  }

  function onChangeQuantity(e) {
    if (e.currentTarget.value > 0) {
      setParsedQuantity(+e.currentTarget.value);
    }
  }

  function decreaseQuantity(e) {
    if (parsedQuantity > 1) {
      setParsedQuantity((prev) => prev - 1);
    }
  }

  function incrementQuantity(e) {
    setParsedQuantity((prev) => prev + 1);
  }

  return (
    <div
      className={cssClass}
      style={{
        display: 'flex',
        flexDirection: 'row',
      }}
      key={`ReorderOrderLineButtonContainer_${parsedQuantity}`}
    >
      <div
        className="qtybox"
        style={{
          backgroundColor: 'white',
          textAlign: 'center',
        }}
      >
        <div
          className={`qtybox__button-minus ${
            parsedQuantity === 1 ? 'disabled' : ''
          }`}
          onClick={decreaseQuantity}
        >
          -
        </div>
        <input
          className="qtybox__input"
          type="number"
          value={parsedQuantity}
          onChange={onChangeQuantity}
        />
        <div className="qtybox__button-plus" onClick={incrementQuantity}>
          +
        </div>
      </div>
      <ReorderOrderLineButton
        title={title}
        onError={onError}
        label={label}
        cssClass={cssButtonClass}
        articleNumber={articleNumber}
        quantity={parsedQuantity}
      />
    </div>
  );
}
